"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Hotel = function Hotel(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-259.000000, -5443.000000)",
    stroke: fill,
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(260.000000, 5444.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polyline", {
    points: "19.7222222 8.47222222 19.7222222 20.9722222 0.277777778 20.9722222 0.277777778 8.47222222"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7222222,8.47222222 L0.277777778,8.47222222 L2.73888889,4.56111111 C2.92782385,3.99385231 3.45858604,3.61116643 4.05648148,3.61111111 L15.9435185,3.61111111 C16.541414,3.61116643 17.0721762,3.99385231 17.2611111,4.56111111 L19.7222222,8.47222222 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.3888889,20.9722222 L8.61111111,20.9722222 L8.61111111,16.8055556 C8.61111111,16.0384934 9.23293785,15.4166667 10,15.4166667 C10.7670622,15.4166667 11.3888889,16.0384934 11.3888889,16.8055556 L11.3888889,20.9722222 Z"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "3.05555556",
    y1: "11.25",
    x2: "5.83333333",
    y2: "11.25"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "8.61111111",
    y1: "11.25",
    x2: "11.3888889",
    y2: "11.25"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "14.1666667",
    y1: "11.25",
    x2: "16.9444444",
    y2: "11.25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "3.05555556 14.0277778 5.83333333 14.0277778 5.83333333 16.8055556 3.05555556 16.8055556"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "14.1666667 14.0277778 16.9444444 14.0277778 16.9444444 16.8055556 14.1666667 16.8055556"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "5.13888889 0.138888889 7.91666667 0.138888889 7.91666667 3.61111111 5.13888889 3.61111111"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    transform: "translate(13.472222, 1.875000) rotate(-180.000000) translate(-13.472222, -1.875000) ",
    points: "12.0833333 0.138888889 14.8611111 0.138888889 14.8611111 3.61111111 12.0833333 3.61111111"
  })))));
};
Hotel.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Hotel.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Hotel;